<script>
  // Renders an array of strings as small badges. `value` is string[] (or a
  // comma string). Column may set `max` to cap visible tags (+N more) and
  // `badges` ({ tag: { label, badgeClass } }) to color specific tags.
  let { value, column = {} } = $props()
  const list = $derived(Array.isArray(value) ? value : value ? String(value).split(',').map((s) => s.trim()) : [])
  const max = $derived(column.max ?? 4)
  const shown = $derived(list.slice(0, max))
  const extra = $derived(Math.max(0, list.length - max))
  // badge-outline, not soft neutral (dark-on-dark on dark themes) and not ghost
  // (blends into the row background) — a bordered chip reads as a badge everywhere
  const badgeFor = (tag) => column.badges?.[tag] ?? { label: tag, badgeClass: 'badge-outline' }
  const hiddenLabels = $derived(list.slice(max).map((tag) => badgeFor(tag).label).join(', '))
</script>

{#if list.length}
  <div class="flex flex-wrap gap-1">
    {#each shown as tag}
      {@const badge = badgeFor(tag)}
      <span class="badge badge-sm whitespace-nowrap {badge.badgeClass}">{badge.label}</span>
    {/each}
    {#if extra}<span class="badge badge-sm badge-outline" title={hiddenLabels}>+{extra}</span>{/if}
  </div>
{:else}
  <span class="text-base-content/40">—</span>
{/if}
